import { FC } from 'react';
import { Container, Rows } from '../styles';
import { TableHeader } from './tableHeader';
import { GridTableProps } from '../types';
import { GridRows } from './gridRows';
import { withPreloader } from 'shared/ui/spinner';

export const GridTable: FC<GridTableProps> = ({
	headers,
	tableRows,
	isLoading = false,
	error = null,
	gridSettings = {
		moreSpaceForLastColumn: true,
		columnSize: 1,
		trackSize: 3,
	},
	gridStyles = {
		rowsPadding: '',
		rowsHeight: '',
		rowCardColor: '',
		rowPadding: '',
	},
	specificColumnSizes,
	selectedRowId = undefined,
	isLoadingBottom = false,
	onClickOnCard,
	onScrollEnd,
	columnCount,
	notFoundText = 'К сожалению мы не нашли информацию по заданным фильтрам',
	isFixedHeader = false,
}) => {
  const GridRowsWithLoader = withPreloader(GridRows);

	return (
		<Container>
			<Rows
				$rowsHeight={gridStyles.rowsHeight}
				$rowsPadding={gridStyles.rowsPadding}
			>
				{headers && (
					<TableHeader
						headers={headers}
						specificColumnSizes={specificColumnSizes}
						isFixedHeader={isFixedHeader}
					/>
				)}
				<GridRowsWithLoader
					isLoading={isLoading}
					isLoadingBottom={isLoadingBottom}
					tableRows={tableRows}
					columnCount={columnCount}
					gridSettings={gridSettings}
					gridStyles={gridStyles}
					specificColumnSizes={specificColumnSizes}
					selectedRowId={selectedRowId}
					onClickOnCard={onClickOnCard}
					onScrollEnd={onScrollEnd}
					error={error}
					notFoundText={notFoundText}
				/>
			</Rows>
		</Container>
	);
};
